module.exports = __webpack_public_path__ + "static/media/whats.cd8f3f33.svg";